import { shallowEqual } from 'shallow-equal-object';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type ValueObjectProps = Record<string, any>;

export abstract class ValueObject<T extends ValueObjectProps> {
  public readonly props: T;

  public constructor(props: T) {
    this.props = Object.freeze(props);
  }

  public equals(vo?: ValueObject<T>): boolean {
    if (vo === null || vo === undefined) {
      return false;
    }
    if (vo.props === undefined) {
      return false;
    }
    return shallowEqual(this.props, vo.props);
  }
}
